import { FC } from 'react'
import ResultBase from '../ResultBase'
import styles from './Reflection.module.css'
import { StepResult } from '../../../types/Result'

interface ReflectionProps {
  result: StepResult
}

const Reflection: FC<ReflectionProps> = ({ result }) => {
  return (
    <ResultBase>
      <div className={styles.container}>{result.header}</div>
    </ResultBase>
  )
}

export default Reflection
